import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

// Used by animations, see following issue for expanition:
// https://github.com/angular/angular/issues/29439
@Directive({
  selector: '[pxwIfUndefinedChanges]',
  standalone: true,
})
export class IfUndefinedChangesDirective {
  private currentValue: any;
  private hasView = false;

  private viewContainer = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef);
  
  constructor() {}

  @Input() set pxwIfUndefinedChanges(val: any) {
    if (!this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      this.currentValue = val;
    } else if (val !== this.currentValue && (!this.currentValue || !val)) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.currentValue = val;
    }
  }
}
